import { render, staticRenderFns } from "./indexNav.vue?vue&type=template&id=5f5b6828&scoped=true"
import script from "./indexNav.vue?vue&type=script&lang=js"
export * from "./indexNav.vue?vue&type=script&lang=js"
import style0 from "./indexNav.vue?vue&type=style&index=0&id=5f5b6828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5b6828",
  null
  
)

export default component.exports